import SysMessage from './SysMessage'

export const sysMessage = {
  data() {
    return {
      sysMessage: false
    }
  },
  methods: {
    doSysMessage() {
      this.sysMessage = true
    }
  },
  components: {
    SysMessage
  }
}
